export default __webpack_public_path__ + "static/media/bz.4c3b883b.svg";